export class IndividualNameViewModel{
    prefix : string ;
    givenName : string ;
    middleName : string ;
    surName : string ;
    patronomical : string ;
    suffix : string ;
}